<div class="row">
	<div class="col-xl-6 col-12 mg-b50" *ngIf="questionUrl">
      <div class="player-wrapper">
        <div style="width: 100%;">
          <app-question-jwplayer [questionUrl]="questionUrl" [playerindex]="playerindex"></app-question-jwplayer>
        </div>
      </div>
	</div>
	<div class="col-12 mg-b30" [class.col-xl-6]="questionUrl">
		<ng-container *ngIf="!isSubmitted">
			<div *ngIf="fileShowProgress" class="pd-t20 pd-b20">
				<div class="progress">
					<div class="progress-bar bg-success" [class.animated-progress]="progress!=100" [ngStyle]="{'width': progress+'%'}"></div>
				</div>
			</div>
			<div *ngIf="!showRecorder && !fileShowProgress">
				<div *ngIf="!source" style="margin: 0 auto; max-width: 225px; min-height: 330px;" class="new-options new-options__twothird-width pt-xl-5">
					<div class="d-block">
						<div class="record record--small mg-b30 pr-0">
							<div class="record__block record__block--bordered-solid record__block--leftalign text-center" *ngIf="(deviceInfo.os == 'Mac' || deviceInfo.os == 'iOS')  && (deviceService.isTablet() || deviceService.isMobile()) && deviceInfo.browser != 'Safari'; else showRecorderOption">
								<a href="javascript:void(0)" class="record__uploadtitle font-12">To use our inbuilt recorder use Safari browser.</a>
							</div>
							<ng-template #showRecorderOption>
								<div (click)="runR()" class="p-3 record__block record__block--bordered-solid record__block--leftalign" style="min-height: 90px;">
									<a href="javascript:void(0)" class="record__block__circlebtn"> <i class="icon-record-video"></i>
									</a> <a href="javascript:void(0)" class="record__uploadtitle font-12 montserrat-semibold primaryColor text-uppercase">Record Video</a>
								</div>
							</ng-template> <span class="record__title darkgrayColor pd-t10 font-10">Record your responses in under 2 min</span>
						</div>
						<div class="record record--small pr-0">
							<!-- <span class="record__title record__title--large mg-b10">Already have a video recording?</span> -->
							<!--Mobile-->
							<div appDnd (filesChangeEmiter)="onFilesChange($event)" [allowed_extensions]="['mp4','mov']" (filesInvalidEmiter)="filesInvalidEmiter($event)" class="py-2 px-3 position-relative record__block record__block--leftalign d-md-none d-inline-block" style="min-height: 0;">
								<input #myInputMobile (change)="onFilesChange($event.target.files)" accept="video/*" type="file" class="droppable-file">
								<span class="record__subtitle"><span class="record__uploadtitle font-12 montserrat-semibold record__uploadtitle--primary">OR UPLOAD VIDEO</span></span>
							</div>
							<!--Desktop-->
							<div appDnd (filesChangeEmiter)="onFilesChange($event)" [allowed_extensions]="['mp4','mov']" (filesInvalidEmiter)="filesInvalidEmiter($event)" class="py-2 px-3 position-relative record__block record__block--leftalign d-none d-md-inline-block" style="min-height: 0;background: rgb(247, 248, 250)">
								<input #myInputDesktop (change)="onFilesChange($event.target.files)" accept=".mp4,.mov" type="file" class="droppable-file">
								<span class="record__subtitle"><span class="record__uploadtitle font-12 montserrat-semibold record__uploadtitle--primary">OR UPLOAD VIDEO</span></span>
							</div>
							<span class="record__title darkgrayColor pd-t10 font-10">MP4 or MOV file under 100 MB</span>
						</div>
					</div>
				</div>
				<div *ngIf="(showProgress && !fileSizeExceeded) || source" class="video-recorder position-relative" style="margin-top: -40px;">
					<div class="d-flex align-items-center justify-content-between mg-b10" *ngIf="source">
						<h3 class="font-14 montserrat-bold navColor">Your uploaded video</h3>
						<a href="javascript:void(0)" (click)="show()" style="z-index:100" class="btn btn-primary btn-sm video-recorder__btn"><span><i class="icon-delete-fill"></i> Delete</span></a>
					</div>
					<video *ngIf="source" controlsList="nodownload" disablepictureinpicture controls class="recorded-video" [src]="source | safeHtml"></video>
					<!-- <img class="image-full" src="assets/images/video-recorder.jpg" alt=""> -->
					<div *ngIf="showDeleteModal" class="delete-confirmation text-center">
						<div class="delete-confirmation__action"> <a href="javascript:void(0)" (click)="hide()" class="btn btn-about btn-outline-primary min-width209 ms-1 me-1 mb-2"><span>Cancel</span></a>
							<a href="javascript:void(0)" (click)="delete()" class="ms-1 me-1 mb-2 btn btn-primary long-btn40 min-width209"><span>Yes, Delete</span></a>
						</div>
					</div>
				</div>
				<div *ngIf="fileList.length > 1">
					<p class="error">Only One Video can be selected.</p>
				</div>
			</div>
			<div class="video-recorder" style="padding-top: 15px; margin-top: -53px;" *ngIf="showRecorder">
				<div class="d-flex align-items-center justify-content-between mg-b10">
					<h3 class="font-14 montserrat-bold navColor">Record your video</h3>
					<a href="javascript:void(0)" (click)="reset()" class="record__close"><i class="icon-close"></i></a>
				</div>
				<iframe cameraTagIFrame style="overflow: hidden; width: 100%; border: medium none; height: 330px;" class="video-recorder" (load)="load()" allow="geolocation; microphone; camera" [src]="'assets/iframe/video.html?recorderId='+recorderId | safeHtml"></iframe>
			</div>
		</ng-container>
		<ng-container *ngIf="isSubmitted">
			<div [class.notanswered]="!source" class="video-recorder ms-0 me-0">
				<video controls controlsList="nodownload" disablepictureinpicture class="image-full" [src]="source | safeHtml"></video>
			</div>
		</ng-container>
	</div>
	<div class="col-12 pt-3 pb-3">
		<a href="https://courses.harappa.education/hc/en-us/articles/5080549710609-I-am-unable-to-upload-my-video-How-do-I-fix-this-" target="_blank" class="regular-link d-block" alt="Help">Need Help? Here is a quick guide.</a>
	</div>
</div>
<!-- Android Webview send file (video) url -->
<button id="filePathIdForVideo" (click)="sendRecordFilePathForVideo()" style="display: none;"></button> <br>
<!-- Android webview callback function for record audio file -->
